import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import DatePickerInput from 'components/DatePickerInput';
import Glyph from 'components/Glyph';
import SchedulingDisabledTooltipWithButton from 'chat/components/SchedulingDisabledTooltipWithButton';
import { Target } from 'entities/Message';
import TimePickerInput from 'components/TimePickerInput';
import { allTargetsAreGroups } from 'lib/RoleBasedMessagingUtils';
import { getNext30MinuteInterval } from 'lib/SchedulingMessage';

export type Props = {
  scheduledTime?: Date;
  schedulerOpened: boolean;
  targets: Target[];
  districtIsSelected?: boolean;
  onToggleScheduler: () => void;
  onDatePickerChanged: (inputDate?: Date) => void;
  onTimePickerChanged: () => void;
  isEditingScheduledMessage?: boolean;
};

export default class VisualComposerScheduler extends React.Component<Props> {
  renderScheduleButton() {
    const { targets, districtIsSelected } = this.props;
    const tryingToScheduleSendToFew = !allTargetsAreGroups(targets);

    const button = (
      <Button
        data-test-selector="visual_composer_schedule_button"
        level="secondary"
        size="small"
        weight="normal"
        onClick={this.props.onToggleScheduler}
        disabled={tryingToScheduleSendToFew}
      >
        Schedule
      </Button>
    );

    if (districtIsSelected) {
      return null;
    } else if (tryingToScheduleSendToFew) {
      return <SchedulingDisabledTooltipWithButton button={button} />;
    } else {
      return button;
    }
  }

  render() {
    const { scheduledTime, schedulerOpened } = this.props;

    if (!schedulerOpened) {
      return this.renderScheduleButton();
    }

    const placement = 'top';
    const interval = getNext30MinuteInterval();
    const isDateInPast = !!scheduledTime && new Date() > scheduledTime;

    const datePicker = (
      <DatePickerInput
        className="VisualComposer-scheduler-input"
        value={scheduledTime}
        min={interval}
        onChange={this.props.onDatePickerChanged}
        placement={placement}
      />
    );

    const timePicker = (
      <TimePickerInput
        className="VisualComposer-scheduler-input"
        error={isDateInPast}
        value={scheduledTime}
        min={interval}
        onChange={this.props.onTimePickerChanged}
        placement={placement}
      />
    );

    const closeButton = this.props.isEditingScheduledMessage ? null : (
      <Button
        className="VisualComposer-scheduler-closeButton"
        level="text"
        onClick={this.props.onToggleScheduler}
        aria-label="Close"
        data-test-selector="close-scheduler"
      >
        <Glyph name="close-circle" color="mascot" size="large" solo />
      </Button>
    );

    return (
      <div className="VisualComposer-scheduler" data-test-selector="visual_composer_scheduler">
        Send on {datePicker} at {timePicker}
        {closeButton}
      </div>
    );
  }
}
